export default __webpack_public_path__ + "static/media/kh.791bd105.svg";